import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { apiService } from "../../services/apiService";

export const fetchShoppingMonthlyReport = createAsyncThunk(
  "shoppingMonthlyReport/fetchShoppingMonthlyReport",
  async (_, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token");
      const response = await apiService.get("/shopping/generate-monthly-report", {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "applictaion/json",
        },
      });

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const shoppingMonthlyReportSlice = createSlice({
  name: "shoppingMonthlyReport",
  initialState: {
    shoppingMonthlyReports: [],
    status: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchShoppingMonthlyReport.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchShoppingMonthlyReport.fulfilled, (state, action) => {
        state.status = "success";
        state.shoppingMonthlyReports = action.payload.data;
      })
      .addCase(fetchShoppingMonthlyReport.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      });
  },
});

export default shoppingMonthlyReportSlice.reducer;
